<template>
  <header class="header" :class="{ mini: is_mini }">
    <div class="inner">
      <h1 class="logo">
        <router-link to="/">
          <svg-icon name="home-logo" />
          <div>
            <em>{{ $store.state.site_description }}</em
            ><br />
            {{ $store.state.site_name }}
          </div>
        </router-link>
      </h1>
    </div>
  </header>
  <div class="header-bg"></div>
</template>

<script>
import Link from "@/components/ui/Link.vue";

export default {
  name: "Header",

  components: {
    Link,
  },

  data() {
    return {
      is_mini: false,
    };
  },

  methods: {
    toggleMenu() {
      this.EventBus.emit("toggle-navi");
    },

    handleScroll() {
      if (window.scrollY > 80) {
        this.is_mini = true;
      } else {
        this.is_mini = false;
      }
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
.header-bg {
  height: 12rem;

  @media screen and (max-width: 780px) {
    height: 8rem;
  }
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  opacity: 1;
  width: 100%;
  transition: opacity 0.3s ease-in-out;

  .inner {
    position: sticky;
    top: 0;
    z-index: 1000;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  @at-root {
    .open-navi & {
      opacity: 0;
      pointer-events: none;
    }
  }

  .logo {
    padding: var(--padding-x3) 0;
    transition: all 0.3s ease;
    position: relative;
    // left: -2rem;

    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: var(--color-text);

      svg {
        width: 20rem;
        height: 8rem;
        fill: var(--color-text);
        transition: all 0.3s ease;
      }

      div {
        margin-left: 6rem;
        font-size: var(--carousel-size);
        line-height: 1.3;
        transition: all 0.3s ease;
      }
    }
  }

  @media screen and (max-width: 780px) {
    .inner {
      padding: 0 var(--padding);
    }

    .logo {
      padding: 1.8rem 0;

      a {
        svg {
          width: 10rem;
          height: 4.8rem;
        }

        div {
          margin-left: var(--padding);
          font-size: 1.8rem;
        }
      }
    }
  }

  &.mini {
    @media screen and (min-width: 780px) {
      & + .header-bg + .navi-tirgger {
        top: 2.5rem;
      }

      .logo {
        padding: 1.6rem 0;

        a {
          svg {
            width: 13rem;
            height: 4rem;
          }

          div {
            margin-left: var(--padding);
            font-size: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
